import React, { useState } from 'react';
import { Paper, Tabs, Tab, TabPanel } from '@kambi/spark';

import classes from '../../../App.module.css';
import CodeBlock from 'components/layout/code-block/CodeBlock';
import SelectedOutcomes from '../jsonExamples/SelectedOutcomes';
import BetErrorsIndexes from '../jsonExamples/BetErrorsIndexes';

const GetSystemCombinationsTabs = () => {
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className={classes.Tabs}>
            <Paper>
                <Tabs
                    kind="inverted"
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    <Tab label="selectedOutcomes" />
                    <Tab label="betErrorsIndexes" />
                </Tabs>
            </Paper>
            <TabPanel index={0} value={value} className={classes.TabPanel}>
                <p>
                    <strong>selectedOutcomes</strong> parameter is an array
                    containing all outcomes selected by the player. each outcome
                    should have the following properties:
                </p>
                <ul>
                    <li>
                        id: number | string // required: the id of the selected
                        outcome
                    </li>
                    <li>
                        odds: number // required: the odds of the outcome
                        selected, in milli format
                    </li>
                    <li>
                        startingPrice: boolean // not required: if one of the
                        outcomes has this set to true then the combination in
                        which this outcome is present will have a non-numeric
                        total odds{' '}
                    </li>
                </ul>
                <CodeBlock
                    title={SelectedOutcomes.title}
                    initialDisplayedCode={SelectedOutcomes.initialDisplayedCode}
                />
            </TabPanel>
            <TabPanel index={1} value={value} className={classes.TabPanel}>
                <p>
                    <strong>betErrorsIndexes</strong> should contain the indexes
                    that are not valid as combinations related to the specific
                    bets
                </p>
                <p>
                    In the example provided we have 3 possible combinations:
                    outcome with "id": 1234, outcome with "id": 45678 and the
                    combination ["id": 1234, "id": 45678]. Since indexes 0 and 1
                    are filtered out we will only return the combination ["id":
                    1234, "id": 45678]
                </p>
                <CodeBlock
                    title={BetErrorsIndexes.title}
                    initialDisplayedCode={BetErrorsIndexes.initialDisplayedCode}
                />
            </TabPanel>
        </div>
    );
};

export default GetSystemCombinationsTabs;
